export const API_BASE_URL =
	'https://internal.supremecomponents.com/zeeshanapi/api';
